/* eslint-disable @angular-eslint/no-inputs-metadata-property */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { BaseFormControlDirective, BaseFormControlDirectiveInputs } from '../directives/base-form-control.directive';
import {
  ErrorsFormControlDirective,
  ErrorsFormControlDirectiveInputs,
} from '../directives/errors-form-control.directive';
import {
  InputWrapperFormControlDirective,
  InputWrapperFormControlDirectiveInputs,
} from '../directives/input-wrapper-form-control.directive';
import { TextFormControlDirective, TextFormControlDirectiveInputs } from '../directives/text-form-control.directive';
import { CommonModule } from '@angular/common';
import { FormErrorComponent } from '../form-error/form-error.component';
import { FormFieldHelpComponent } from '../form-field-help/form-field-help.component';
import { Validators } from '@angular/forms';
import { Logger, LoggerService } from '@shared/utils';

@Component({
  selector: 'ui-input-wrapper',
  templateUrl: './input-wrapper.component.html',
  // pole (input v promítnutém obsahu i uvnitř Optimusu) přes celou šířku
  host: { class: 'w-full [&_input]:block [&_input]:w-full [&_input]:box-border' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormErrorComponent, FormFieldHelpComponent],
  hostDirectives: [
    {
      directive: BaseFormControlDirective,
      inputs: BaseFormControlDirectiveInputs,
    },
    {
      directive: ErrorsFormControlDirective,
      inputs: ErrorsFormControlDirectiveInputs,
    },
    {
      directive: TextFormControlDirective,
      inputs: TextFormControlDirectiveInputs,
    },
    {
      directive: InputWrapperFormControlDirective,
      inputs: InputWrapperFormControlDirectiveInputs,
    },
  ],
})
export class InputWrapperComponent {
  base = inject(BaseFormControlDirective);
  errors = inject(ErrorsFormControlDirective);
  text = inject(TextFormControlDirective);
  inputWrapper = inject(InputWrapperFormControlDirective);
  cd = inject(ChangeDetectorRef);

  private readonly loggerService = inject(LoggerService);
  logger: Logger = this.loggerService.createLogger('InputWrapperComponent');

  isRequired(): boolean {
    return this.inputWrapper.control()?.hasValidator(Validators.required) ?? false;
  }

  get controlTouched(): boolean {
    return this.inputWrapper.whenTouchedShowValidationErrors() && this.inputWrapper.control().touched;
  }

  public callChangeDetection() {
    this.cd.markForCheck();
  }
}
